import { render, staticRenderFns } from "./PaginaNaoEncontrada404.vue?vue&type=template&id=69f8bc41&"
import script from "./PaginaNaoEncontrada404.vue?vue&type=script&lang=js&"
export * from "./PaginaNaoEncontrada404.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
